import * as oc from './services/oc';

export const init = (domContainer: HTMLElement) => oc.parse(domContainer);

export default { init, oc };
